import type { Routes } from '@angular/router';

export const AUTOMATIONS_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () => import('#modules/automations/views/automations/automations.component').then((m) => m.AutomationsComponent),
    },
];
